"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = require("lodash");
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var card_content_1 = tslib_1.__importDefault(require("./content/video/card-content"));
var card_content_2 = tslib_1.__importDefault(require("./content/product/card-content"));
var card_content_3 = tslib_1.__importDefault(require("./content/social/card-content"));
var card_scss_includeInitial_1 = tslib_1.__importDefault(require("./card.scss?includeInitial"));
var withStyles_1 = require("../../../../../common/utils/withStyles");
var VideoCard = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCard, _super);
    function VideoCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCardClick = function () {
            var _a = _this.props, cardData = _a.cardData, onCardClick = _a.onCardClick;
            onCardClick(cardData);
        };
        return _this;
    }
    VideoCard.prototype.getCardAriaLabel = function () {
        var _a = this.props, cardData = _a.cardData, labels = _a.labels;
        switch (cardData.network) {
            case 'twitter':
                return cardData.text + " " + labels.twitterButtonTitle;
            case 'youtube':
                return cardData.text + " " + labels.youtubeButtonTitle;
            case 'facebook':
                return cardData.text + " " + labels.facebookButtonTitle;
            default:
                return null;
        }
    };
    VideoCard.prototype.getContentComponent = function (type) {
        var CHANNEL = types_1.VIDEO_CARD_TYPES.CHANNEL, VIDEO = types_1.VIDEO_CARD_TYPES.VIDEO, RECENT_VIDEO = types_1.VIDEO_CARD_TYPES.RECENT_VIDEO, CUSTOM = types_1.VIDEO_CARD_TYPES.CUSTOM, PRODUCT = types_1.VIDEO_CARD_TYPES.PRODUCT, SOCIAL = types_1.VIDEO_CARD_TYPES.SOCIAL;
        switch (type) {
            case CHANNEL:
            case VIDEO:
            case RECENT_VIDEO:
                return card_content_1.default;
            case CUSTOM:
            case PRODUCT:
                return card_content_2.default;
            case SOCIAL:
                return card_content_3.default;
            default:
                return card_content_2.default;
        }
    };
    VideoCard.prototype.renderCardContent = function () {
        var _a;
        var _b = this.props, cardData = _b.cardData, isMobile = _b.isMobile, isAccessible = _b.isAccessible, labels = _b.labels;
        var type = cardData.type, text = cardData.text, thumbnailUrl = cardData.thumbnailUrl, buttonLabel = cardData.buttonLabel;
        var typeClassName = card_scss_includeInitial_1.default["card-type-" + type];
        var partsClasses = (_a = {},
            _a[card_scss_includeInitial_1.default['without-text']] = !text,
            _a[card_scss_includeInitial_1.default['without-thumbnail']] = !thumbnailUrl,
            _a[card_scss_includeInitial_1.default['without-cta']] = !buttonLabel,
            _a);
        var cardClassName = classnames_1.default(card_scss_includeInitial_1.default.card, typeClassName, partsClasses);
        var CardContentComponent = this.getContentComponent(cardData.type);
        return (react_1.default.createElement(CardContentComponent, { className: cardClassName, cardData: cardData, isAriaHidden: isMobile, isAccessible: isAccessible, labels: labels }));
    };
    VideoCard.prototype.renderMobileCard = function () {
        var cardData = this.props.cardData;
        return (react_1.default.createElement("a", { className: classnames_1.default(card_scss_includeInitial_1.default.link, card_scss_includeInitial_1.default['link-mobile']), href: cardData.url, tabIndex: 0, role: "option", "aria-label": this.getCardAriaLabel(), rel: "noopener noreferrer", onClick: this.onCardClick, target: "_blank" }, this.renderCardContent()));
    };
    VideoCard.prototype.renderPlayerCard = function () {
        var _a = this.props, isAccessible = _a.isAccessible, cardData = _a.cardData;
        return (react_1.default.createElement("a", { className: card_scss_includeInitial_1.default.link, href: cardData.url, "aria-hidden": !isAccessible, tabIndex: isAccessible ? 0 : -1, rel: "noopener noreferrer", onClick: this.onCardClick, target: "_blank" }, this.renderCardContent()));
    };
    VideoCard.prototype.render = function () {
        var isMobile = this.props.isMobile;
        return isMobile ? this.renderMobileCard() : this.renderPlayerCard();
    };
    VideoCard.propTypes = {
        cardData: prop_types_1.default.object,
        onCardClick: prop_types_1.default.func,
        isAccessible: prop_types_1.default.bool,
        isMobile: prop_types_1.default.bool,
        labels: prop_types_1.default.object,
    };
    VideoCard.defaultProps = {
        onCardClick: lodash_1.noop,
        labels: {},
    };
    VideoCard = tslib_1.__decorate([
        withStyles_1.withStyles(card_scss_includeInitial_1.default)
    ], VideoCard);
    return VideoCard;
}(react_1.default.Component));
exports.default = VideoCard;
//# sourceMappingURL=card.js.map